export const getDefaultBanksState = () => {
    return {
        result: null,
        expandAll: false,
        sortField: "rate",
        sortDirection: "asc",
        orderedBankIds: [],
        comparedBanks: [],
        hiddenBanks: [],
        currentView: "all",
    };
};
export const state = getDefaultBanksState();
